// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
.loading-container ion-spinner {
  margin-bottom: 16px;
}

ion-toggle {
  font-weight: 600;
  --track-background-checked: #ed143d;
}

ion-label {
  white-space: normal !important;
}
ion-label h2 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
}
ion-label p {
  font-size: 14px;
  color: var(--ion-color-medium);
  margin-top: 4px;
  white-space: normal;
  overflow: visible;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/notification-preferences-modal/notification-preferences-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,gBAAA;EACA,mCAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,eAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AADJ","sourcesContent":[".loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n\n  ion-spinner {\n    margin-bottom: 16px;\n  }\n}\n\nion-toggle {\n  font-weight: 600;\n  --track-background-checked: #ed143d;\n}\n\nion-label {\n  white-space: normal !important;\n\n  h2 {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 4px;\n  }\n\n  p {\n    font-size: 14px;\n    color: var(--ion-color-medium);\n    margin-top: 4px;\n    white-space: normal;\n    overflow: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
